import baseScmService from 'services/baseScmService';

const sbatGroupLectureContentService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    createSbatGroupLectureContent: build.mutation({
      query: ({ sbatGroupId, content }) => ({
        method: 'POST',
        url: `/sbat-groups/${sbatGroupId}/lecture-contents/`,
        body: {
          lecture_content: content,
        },
      }),
      invalidatesTags: (result, error, { sbatGroupId }) =>
        error ? [] : [{ type: 'SbatGroup', id: sbatGroupId }],
    }),
    deleteSbatGroupLectureContent: build.mutation({
      query: ({ sbatGroupId, lectureContentId }) => ({
        method: 'DELETE',
        url: `sbat-groups/${sbatGroupId}/lecture-contents/${lectureContentId}`,
      }),
      invalidatesTags: (result, error, { sbatGroupId }) =>
        error ? [] : [{ type: 'SbatGroup', id: sbatGroupId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateSbatGroupLectureContentMutation,
  useDeleteSbatGroupLectureContentMutation,
} = sbatGroupLectureContentService;

export default sbatGroupLectureContentService;
